// extracted by mini-css-extract-plugin
export default {"base":"Menu_base__o2UGy","baseone":"Menu_baseone__pFApP","open":"Menu_open__wE18i"};